import i18n from '@atpoint/atpjs/helpers/i18n'
import { Grid } from '@material-ui/core'
import { Map as ImmutableMap } from 'immutable'
import { useCallback } from 'react'
import { Input } from 'swisscard/components/form'
import { inputStyles } from 'swisscard/components/form/input_styles'

type NamesInputProps = {
  errorMessage?: ImmutableMap<string, any>
  focused?: boolean
  id?: string
  label: string
  value: ImmutableMap<string, any> | null
  onChange: (value: ImmutableMap<string, any>) => void
}

export const InputNames = (props: NamesInputProps) => {
  let { value: name } = props
  const { errorMessage = ImmutableMap({}), focused, id, label, onChange } = props

  name = name || ImmutableMap({ first_name: '', last_name: '' })

  const onChangeFirstName = useCallback(
    (value: string) => {
      name && onChange(name.set('first_name', value))
    },
    [name, onChange],
  )

  const onChangeLastName = useCallback(
    (value: string) => {
      name && onChange(name.set('last_name', value))
    },
    [name, onChange],
  )

  const classes = inputStyles()

  return (
    <div className={classes.inputWrapper}>
      <label className={classes.labelDefault} htmlFor={`${id}-firstName`}>
        {label}
      </label>
      <Grid container>
        <Grid item xs={12} sm={6}>
          <Input
            errorMessage={errorMessage.get('first_name')}
            focused={focused}
            label={i18n.trans(['names', 'firstName'])}
            id={`${id}-firstName`}
            type="text"
            value={name.get('first_name')}
            onChange={onChangeFirstName}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Input
            errorMessage={errorMessage.get('last_name')}
            id={`${id}-lastName`}
            label={i18n.trans(['names', 'lastName'])}
            type="text"
            value={name.get('last_name')}
            onChange={onChangeLastName}
          />
        </Grid>
      </Grid>
    </div>
  )
}
